export const fmtCurrency = (v) => {
  const n = Number(v) || 0;
  return n.toLocaleString("en-NZ", {
    style: "currency",
    currency: "NZD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const fmtCurrency0 = (v) => {
  const n = Number(v) || 0;
  return n.toLocaleString("en-NZ", {
    style: "currency",
    currency: "NZD",
    maximumFractionDigits: 0,
  });
};

export const fmtPercent = (v) => {
  const n = Number(v) || 0;
  return `${(n * 100).toFixed(1)}%`;
};

export const fmtNum = (v) => (Number(v) || 0).toLocaleString("en-NZ");

export const HOLIDAY_PAY_RATE = 0.08;
export const KIWISAVER_RATE = 0.03;

export const PROGRAMMES = ["Before School", "After School", "Holiday Programme", "Other"];

export const PROGRAMME_COLORS = {
  "Before School": "#3B82F6",
  "After School": "#F59E0B",
  "Holiday Programme": "#34D399",
  "Other": "#94A3B8",
  "Special days": "#A78BFA",
};

// The lines on the finance reports: the programmes plus one-off special days (teachers-only days ...), which get their own line once there is one.
export const FINANCE_PROGRAMMES = [...PROGRAMMES, "Special days"];

// Roster/payroll shift categories — kept separate from PROGRAMMES since "Admin" is a staff-only
// hours category, never a bookable child programme.
export const SHIFT_TYPES = ["Admin", "Before School", "After School", "Holiday Programme", "Special days"];

export const SHIFT_TYPE_COLORS = {
  Admin: "#A78BFA",
  "Before School": "#3B82F6",
  "After School": "#F59E0B",
  "Holiday Programme": "#34D399",
  "Special days": "#A78BFA",
};

export const OVERHEAD_CATS = [
  { key: "rent", label: "Rent" },
  { key: "officeAdmin", label: "Office Admin" },
  { key: "subscriptions", label: "Subscriptions" },
  { key: "equipment", label: "Equipment" },
  { key: "general", label: "General Expenses" },
  { key: "phoneInternet", label: "Phone / Internet" },
  { key: "staffTraining", label: "Staff Training" },
  { key: "staffRecruitment", label: "Staff Recruitment" },
  { key: "consultancy", label: "Consultancy" },
];

export const termChipClass = (t) =>
  /Holidays/.test(t || "")
    ? "bg-[#A78BFA]/15 text-[var(--hp-c-lavender)] border border-[#A78BFA]/30"
    : t === "Unassigned"
      ? "bg-[var(--hp-tint-5)] text-[var(--hp-muted)] border border-[var(--hp-border-tint)]"
      : "bg-[#F472B6]/15 text-[var(--hp-c-pink)] border border-[#F472B6]/30";

export const programmeChipClass = (p) => {
  const map = {
    "Before School": "bg-[#3B82F6]/15 text-[var(--hp-c-blue)] border border-[#3B82F6]/30",
    "After School": "bg-[#F59E0B]/15 text-[var(--hp-c-amber)] border border-[#F59E0B]/30",
    "Holiday Programme": "bg-[#10B981]/15 text-[var(--hp-profit)] border border-[#10B981]/30",
    "Other": "bg-[var(--hp-tint-5)] text-[var(--hp-muted)] border border-[var(--hp-border-tint)]",
  };
  return map[p] || map["Other"];
};

// "Out of School Hub" -> "Out_of_School_Hub": a provider's name made safe for a download filename.
export const fileBase = (name) => String(name || "Report").replace(/[^A-Za-z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "Report";

// Axis tick label for money: "$450", "$1.5k", "$2k", "-$1.2k" -- keeps one decimal so neighbouring ticks
// (0, 0.5k, 1k...) don't all round to the same "$1k" label.
export const fmtAxisMoney = (v) => {
  const n = Number(v) || 0; const a = Math.abs(n); const sign = n < 0 ? "-" : "";
  if (a < 1000) return `${sign}$${Math.round(a)}`;
  const k = a / 1000;
  return `${sign}$${Number.isInteger(k) ? k : k.toFixed(1)}k`;
};
